import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_9 = ({ eyeColours, skinColours }) => {
  const colour0 = '#F15743';
  const colour1 = '#573D39';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <g>
            <path
              fill={colour0}
              opacity={0.5}
              d="M430,392.8c-2.8-0.9-11.9-6.1-11.6-7.3c5.1-8.9,17.4-29.6,17.4-29.6L430,392.8z"
            />
            <path
              fill={colour1}
              d="M480.6,390.6c3-0.9,7.9-4.5,7.7-5.7c-0.9-6.1-10.9-22.3-10.9-22.3L480.6,390.6z"
            />
            <path
              fill={colour1}
              d="M483,384.8c0-20.2-13.5-37.9-28.7-37.9c-15.2,0-27.5,16.4-27.5,36.6s12.3,36.6,27.5,36.6
				C469.5,420.2,483,405.1,483,384.8z"
            />
            <path
              fill={colour2}
              d="M479.5,383.6c0-19.5-11.3-35.4-25.2-35.4s-25.2,15.8-25.2,35.4c0,19.5,11.3,32,25.2,32
				S479.5,403.1,479.5,383.6z"
            />
            <path
              fill={colour3}
              d="M455.7,411.1c-13.9,0-25.2-13.4-25.2-32.9c0-3.1,0.3-6.2,0.8-9.1c-1.4,4.4-2.2,9.4-2.2,14.6
				c0,19.5,11.3,32.9,25.2,32.9c11.8,0,21.7-9.7,24.4-24.6C474.8,403.7,466,411.1,455.7,411.1z"
            />
            <path
              fill={colour4}
              d="M468.8,384.6c0-11-6.7-19.9-14.9-19.9c-8.2,0-14.9,8.9-14.9,19.9c0,11,6.7,19.9,14.9,19.9
				C462.2,404.5,468.8,395.6,468.8,384.6z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M488.3,384.7c-6.5-17.7-16.6-34.8-32-34.8c-13.9,0-31.6,13.9-34,30.4c14.1-25.7,42.3-37.1,61.8-1.8
				C485.3,380.9,487.1,382,488.3,384.7z"
            />
            <path
              fill={colour6}
              d="M423,377c6.8-24.9,42.3-49.6,63.9,4.1c0,0-5.2-35.8-31.2-35.8C425.5,345.3,423,377,423,377z"
            />
            <path
              fill={colour2}
              d="M446,391.4c-0.6-2.8-2.5-4.8-4.3-4.4c-1.8,0.4-2.8,2.9-2.3,5.7c0.6,2.8,2.5,4.8,4.3,4.4
				C445.6,396.7,446.6,394.2,446,391.4z"
            />
            <path
              fill={colour2}
              d="M445.5,381.4c0.3-1.6-0.1-2.9-0.9-2.9c-0.8,0-1.7,1.2-2,2.8c-0.3,1.6,0.1,2.9,0.9,2.9
				C444.3,384.2,445.2,383,445.5,381.4z"
            />
          </g>
          <path
            fill={colour6}
            d="M426.4,390.9c0,0,4.4,27.9,23.7,30s30.4-12.6,33.5-29.7c0,0-15.5,20.4-30.7,17.6
			C437.8,406.1,426.4,390.9,426.4,390.9z"
          />
          <path
            fill={colour1}
            d="M411.3,386.9c15.7-4.1,21.8,24.7,40.7,24.2c24.3-0.6,32.1-24.7,43.1-23.1c0,0-2.7-3.4-6.7-3.2
			c-4,0.3-19.3,24.1-36.5,23.1C434.6,406.9,428.1,379.3,411.3,386.9z"
          />
          <path
            fill={colour1}
            d="M455.7,348.1c-19-1-29.7,19.3-32,25.5c-2.2,6.3-7.3,11-11.8,13l7.1-0.5c0,0,3.7-3,6.2-10
			c7.7-21.6,24.7-23.6,29.3-23.3c27.1,1.7,31.7,34.2,31.7,34.2l5.6-1.6C485.3,384.9,480.7,349.4,455.7,348.1z"
          />
          <path
            fill={colour1}
            d="M492.2,362.5c0,0-9.1,3.9-14.5,1.7l1.6,2.6C479.4,366.7,487.2,367.8,492.2,362.5z"
          />
          <path
            fill={colour1}
            d="M488.9,357c0,0-7.8,5.9-13.6,5l2.2,2.1C477.5,364.1,485.4,363.3,488.9,357z"
          />
          <path
            fill={colour1}
            d="M485.4,353.1c0,0-7.3,6.5-13.1,6l2.4,1.9C474.7,361.1,482.5,359.7,485.4,353.1z"
          />
          <path
            fill={colour1}
            d="M480.4,349c0,0-6.7,7-12.6,7.1l2.6,1.7C470.4,357.8,478.1,355.8,480.4,349z"
          />
          <path
            fill={colour1}
            d="M472.6,344.8c0,0-3.2,7.3-7.5,8.9l2.3,0.7C467.4,354.4,472.6,350.8,472.6,344.8z"
          />
        </g>
        <g>
          <g>
            <path
              fill={colour0}
              opacity={0.5}
              d="M374.5,392.8c2.8-0.9,11.9-6.1,11.6-7.3c-5.1-8.9-17.4-29.6-17.4-29.6L374.5,392.8z"
            />
            <path
              fill={colour1}
              d="M323.9,390.6c-3-0.9-7.9-4.5-7.7-5.7c0.9-6.1,10.9-22.3,10.9-22.3L323.9,390.6z"
            />
            <path
              fill={colour1}
              d="M321.5,384.8c0-20.2,13.5-37.9,28.7-37.9c15.2,0,27.5,16.4,27.5,36.6s-12.3,36.6-27.5,36.6
				C335,420.2,321.5,405.1,321.5,384.8z"
            />
            <path
              fill={colour2}
              d="M325.1,383.6c0-19.5,11.3-35.4,25.2-35.4c13.9,0,25.2,15.8,25.2,35.4c0,19.5-11.3,32-25.2,32
				C336.3,415.6,325.1,403.1,325.1,383.6z"
            />
            <path
              fill={colour3}
              d="M348.8,411.1c13.9,0,25.2-13.4,25.2-32.9c0-3.1-0.3-6.2-0.8-9.1c1.4,4.4,2.2,9.4,2.2,14.6
				c0,19.5-11.3,32.9-25.2,32.9c-11.8,0-21.7-9.7-24.4-24.6C329.7,403.7,338.5,411.1,348.8,411.1z"
            />
            <path
              fill={colour4}
              d="M335.7,384.6c0-11,6.7-19.9,14.9-19.9c8.2,0,14.9,8.9,14.9,19.9c0,11-6.7,19.9-14.9,19.9
				C342.3,404.5,335.7,395.6,335.7,384.6z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M316.2,384.7c6.5-17.7,16.6-34.8,32-34.8c13.9,0,31.6,13.9,34.1,30.4c-14.1-25.7-42.3-37.1-61.8-1.8
				C319.2,380.9,317.4,382,316.2,384.7z"
            />
            <path
              fill={colour6}
              d="M381.5,377c-6.8-24.9-42.3-49.6-63.9,4.1c0,0,5.2-35.8,31.2-35.8C379,345.3,381.5,377,381.5,377z"
            />
            <path
              fill={colour2}
              d="M335.1,390.7c0-2.9,1.5-5.2,3.3-5.2s3.3,2.3,3.3,5.2c0,2.9-1.5,5.2-3.3,5.2S335.1,393.6,335.1,390.7z"
            />
            <path
              fill={colour2}
              d="M340.5,377.7c0.6-1.5,1.7-2.3,2.4-1.9c0.7,0.4,0.8,2,0.2,3.4c-0.6,1.5-1.7,2.3-2.4,1.9
				C339.9,380.7,339.9,379.2,340.5,377.7z"
            />
          </g>
          <path
            fill={colour6}
            d="M378.1,390.9c0,0-4.4,27.9-23.7,30c-19.4,2.1-30.4-12.6-33.5-29.7c0,0,15.5,20.4,30.7,17.6
			C366.7,406.1,378.1,390.9,378.1,390.9z"
          />
          <path
            fill={colour1}
            d="M393.2,386.9c-15.7-4.1-21.8,24.7-40.7,24.2c-24.3-0.6-32.1-24.7-43.1-23.1c0,0,2.7-3.4,6.7-3.2
			c4,0.3,19.3,24.1,36.5,23.1C369.9,406.9,376.4,379.3,393.2,386.9z"
          />
          <path
            fill={colour1}
            d="M348.8,348.1c19-1,29.7,19.3,32,25.5c2.2,6.3,7.3,11,11.8,13l-7.1-0.5c0,0-3.7-3-6.2-10
			c-7.7-21.6-24.7-23.6-29.3-23.3c-27.1,1.7-31.7,34.2-31.7,34.2l-5.6-1.6C319.2,384.9,323.8,349.4,348.8,348.1z"
          />
          <path
            fill={colour1}
            d="M312.3,362.5c0,0,9.1,3.9,14.5,1.7l-1.6,2.6C325.1,366.7,317.3,367.8,312.3,362.5z"
          />
          <path
            fill={colour1}
            d="M315.6,357c0,0,7.8,5.9,13.6,5l-2.2,2.1C327,364.1,319.1,363.3,315.6,357z"
          />
          <path
            fill={colour1}
            d="M319.1,353.1c0,0,7.3,6.5,13.1,6l-2.4,1.9C329.8,361.1,322,359.7,319.1,353.1z"
          />
          <path
            fill={colour1}
            d="M324.1,349c0,0,6.7,7,12.6,7.1l-2.6,1.7C334.1,357.8,326.4,355.8,324.1,349z"
          />
          <path
            fill={colour1}
            d="M331.9,344.8c0,0,3.2,7.3,7.5,8.9l-2.3,0.7C337.1,354.4,331.9,350.8,331.9,344.8z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_9;
